import {
  format,
  isToday,
  parseISO,
  isYesterday,
  compareDesc,
  formatDistanceToNow,
} from "date-fns";
import { NotificationDto } from "@/modules/notification-center/dtos";

export function groupNotificationsByDate(notifications: NotificationDto[]): {
  grouped: Record<string, NotificationDto[]>;
  sortedKeys: string[];
} {
  const grouped = notifications.reduce<Record<string, NotificationDto[]>>(
    (acc, notification) => {
      const dateKey = notification?.createdAt
        ? format(new Date(notification?.createdAt), "yyyy-MM-dd")
        : "";
      if (!acc[dateKey]) acc[dateKey] = [];
      acc[dateKey].push(notification);
      return acc;
    },
    {}
  );

  const sortedKeys = Object.keys(grouped).sort((a, b) =>
    compareDesc(parseISO(a), parseISO(b))
  );

  return { grouped, sortedKeys };
}

export function formatHumanReadableDate(dateString: string): string {
  const parsedDate = dateString ? parseISO(dateString) : new Date();

  if (isToday(parsedDate)) return "Today";
  if (isYesterday(parsedDate)) return "Yesterday";

  return format(parsedDate, "MMMM d, yyyy");
}

export function getNotificationTimestamps(createdAt: string | Date): {
  relativeTime: string;
  absoluteTime: string;
} {
  const date = createdAt
    ? typeof createdAt === "string"
      ? parseISO(createdAt)
      : createdAt
    : new Date();

  const relativeTime = formatDistanceToNow(date, { addSuffix: true });

  const absoluteTime = isToday(date)
    ? `Today, ${format(date, "hh:mm a")}`
    : format(date, "dd MMM yyyy, hh:mm a");

  return { relativeTime, absoluteTime };
}
